import { load } from "@nextgisweb/jsrealm/i18n/catalog";
load("feature_description", {"":{"Description":["Описание"],"Invalid ZIP archive.":["Некорректный ZIP-архив."]}})